package com.macrofocus.eflux.network

import web.cssom.ClassName
import web.dom.DOMTokenList

val DOMTokenList<ClassName>.voltage: ClassName?
    get() {
        if(contains(ClassName("kv380"))) {
            return ClassName("kv380")
        } else if(contains(ClassName("kv220"))) {
            return ClassName("kv220")
        } else if(contains(ClassName("kv150"))) {
            return ClassName("kv150")
        } else {
            return null
        }
    }

